import request from 'superagent';
import {round} from 'lodash';
import constants from 'client/constants';

/**
 * Image supplements which are cropped need to be retrieved through the imgproxy service.
 * Imgproxy will retrieve the supplement and crop it with the given options in the URL.
 *
 * @param {*} supplement
 * @returns {string} The full URL pointing to the cropped image.
 */
export async function getCroppedImageUrl(supplement) {
  const imagePath = supplement.getImageLocation().path;
  const cropValues = supplement.getCropValues();

  // Get the full image dimensions
  const infoUrl = `${constants.IMAGES_ORIGIN}/info/_/plain/${imagePath}`;
  const infoResponse = await request.get(infoUrl);
  const width = infoResponse.body.width;
  const height = infoResponse.body.height;

  // Calculate crop transform properties using image dimensions
  const crop = {
    x: round(cropValues.get('x') * 0.01 * width),
    y: round(cropValues.get('y') * 0.01 * height),
    width: round(cropValues.get('width') * 0.01 * width),
    height: round(cropValues.get('height') * 0.01 * height)
  };
  const transformOptions = `crop:${crop.width}:${crop.height}:nowe:${crop.x}:${crop.y}`;

  // https://docs.imgproxy.net/usage/processing#crop
  return `${constants.IMAGES_ORIGIN}/_/${transformOptions}/plain/${imagePath}`;
}
